import { z as zod } from 'zod';

export const TelegramIdFormSchema = zod.object({
  id: zod.number().optional(),
  name: zod.string().nonempty({
    message: 'O campo nome é obrigatório e não pode estar vazio.',
  }),
  telegramId: zod.string().nonempty({
    message: 'O campo ID do Telegram é obrigatório e não pode estar vazio.',
  }),
});
